import * as ActionTypes from '../../actions'
import {
    Action,
    ViolationsPagination

} from "../../types";
const defaultState = {
    currPage : 1,
};

export default function(state: ViolationsPagination = defaultState, action: Action) {
    const { type } = action;
   
    switch (type) {
        case ActionTypes.PAGE_CHANGED_TO_NEXT:

            return {
            
                currPage: state['currPage'] += 1,
            };
        case ActionTypes.PAGE_CHANGED_TO_PREV: {

            return {
             
                currPage: state['currPage'] > 1?state['currPage'] -= 1:1,
            };
        }
        
        default: {
            return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/violationHistory/violationsPagination.ts